module.exports = __webpack_public_path__ + "img/red_005.a3553e87.png";